const BaseSize = 32
function setRem () {
    const htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
    const sacle = htmlWidth / 750
    const htmlDom = document.getElementsByTagName('html')[0];
    htmlDom.style.fontSize= BaseSize * Math.min(sacle, 2) + 'px'
}
setRem()
window.onresize = function () {
    setRem()
}